package org.example.project.engineslot

import androidx.compose.runtime.Composable
import org.example.project.settings.AppDropdown
import org.example.project.settings.AppDropdownAppearance
import org.example.project.settings.AppDropdownMenuMode
import org.example.project.utils.All
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexWrap
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.minWidth
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun SlotSetupLayout(
    selectedFirmaLabel: String,
    snapOptions: List<All>,
    selectedSnapKey: String,
    selectedDate: String,
    selectedStandort: String,
    selectedCell: All?,
    config: All,
    standorte: List<All>,
    bookings: List<All>,
    calendarOpen: Boolean,
    loading: Boolean = false,
    onConfigChange: (All) -> Unit,
    onSnapChange: (String) -> Unit,
    onDateChange: (String) -> Unit,
    onToggleCalendar: () -> Unit,
    onStandortChange: (String) -> Unit,
    onSlotSelect: (All, All?) -> Unit,
    onSlotDoubleClick: (All, All?) -> Unit,
    onBookingHover: (All, Double, Double) -> Unit,
    onBookingHoverEnd: () -> Unit,
    onOpenBooking: () -> Unit
) {
    val headline = selectedFirmaLabel.ifBlank { slotStandortHeadline(standorte, selectedStandort) }
    val standortOptions = slotStandortOptions(standorte)
    val canShowGrid = !loading && selectedSnapKey.isNotBlank() && selectedStandort.isNotBlank()
    val firmaOptions = snapOptions.ifEmpty {
        listOf(All(key = selectedSnapKey, label = headline.ifBlank { "Firma" }))
    }

    SlotSharedLayout(
        headline = "",
        address = "",
        config = config.copy(standort = selectedStandort),
        bookings = bookings,
        slotMode = SLOT_VIEW_SETUP,
        selectedDate = selectedDate,
        selectedStandort = selectedStandort,
        selectedCell = selectedCell,
        editMode = false,
        showGrid = canShowGrid,
        actionBar = {},
        topContent = {
            SlotActionBarRow(
                leftContent = {
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            alignItems(AlignItems.Center)
                            justifyContent(JustifyContent.Center)
                            gap(12.px)
                            minWidth(0.px)
                            flexWrap(FlexWrap.Wrap)
                        }
                    }) {
                        Div({
                            style {
                                property("min-width", "max-content")
                                maxWidth(100.percent)
                            }
                        }) {
                            AppDropdown(
                                options = firmaOptions,
                                selectedValue = selectedSnapKey.takeIf { it.isNotBlank() },
                                onChange = onSnapChange,
                                placeholder = "Firma",
                                appearance = AppDropdownAppearance.Underline,
                                menuMode = AppDropdownMenuMode.Overlay
                            )
                        }
                        SlotToolbarSeparator()
                        Div({
                            style {
                                property("min-width", "max-content")
                                maxWidth(100.percent)
                            }
                        }) {
                            AppDropdown(
                                options = standortOptions,
                                selectedValue = selectedStandort.takeIf { it.isNotBlank() },
                                onChange = onStandortChange,
                                placeholder = "Standort",
                                appearance = AppDropdownAppearance.Underline,
                                menuMode = AppDropdownMenuMode.Overlay
                            )
                        }
                    }
                },
                centerContent = {
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            alignItems(AlignItems.Center)
                            justifyContent(JustifyContent.Center)
                            gap(12.px)
                            minWidth(0.px)
                        }
                    }) {
                        SlotDatePager(
                            selectedDate = selectedDate,
                            onDateChange = onDateChange
                        )
                    }
                },
                rightContent = {
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            alignItems(AlignItems.Center)
                            justifyContent(JustifyContent.Center)
                            gap(12.px)
                            flexWrap(FlexWrap.Wrap)
                        }
                    }) {
                        SlotToolbarAction(
                            icon = "images/kalender.svg",
                            label = "Kalender",
                            active = calendarOpen,
                            onClick = onToggleCalendar
                        )
                        if (canShowGrid) {
                            SlotToolbarSeparator()
                            SlotToolbarAction(
                                icon = "images/tourbuchen.svg",
                                label = if (slotIsBooked(selectedCell)) "Bearbeiten" else "Buchen",
                                onClick = onOpenBooking
                            )
                        }
                    }
                }
            )
            if (calendarOpen) {
                SlotCalendarPopup(
                    selectedDate = selectedDate,
                    onDateChange = onDateChange,
                    onClose = onToggleCalendar
                )
            }
        },
        onCellClick = onSlotSelect,
        onBookingHover = onBookingHover,
        onBookingHoverEnd = onBookingHoverEnd,
        onCellDoubleClick = onSlotDoubleClick
    )
}

@Composable
fun GridHeaderCell(text: String) {
    Div({
        classes(SlotStyles.tableHeaderCell)
    }) {
        val labelClass = if (text == "Slot") SlotStyles.tableHeaderLabel else SlotStyles.tableAxisLabel
        Span({ classes(labelClass) }) { Text(text) }
    }
}

@Composable
fun GridHeaderValue(text: String) {
    Div({
        classes(SlotStyles.tableRowHeaderCell)
    }) {
        Span({ classes(SlotStyles.tableRowHeaderValue) }) { Text(text) }
    }
}
